﻿import {translation} from "@2d-front-monorepo/core";
import {PermitTranslations} from "@2d-front-monorepo/shared-translations";
import {JSX} from "react";
import {reservationBlockTypeLabel} from "../helpers/enumNaming";
import {formatCurrency} from "../helpers/formatCurrency";
import {ReservationBlock} from "../types/arguments/FormReservation";
import {PriceBlock} from "../types/arguments/ReservationQuotationResult";
import {InstallationByHostData} from "../types/InstallationByHostData";
import {ReservationResult} from "../types/ReservationResult";
import {Zones} from "../Zones";

interface ReservationBlockRowProps {
	block: ReservationBlock,
	price: PriceBlock,
	installation: InstallationByHostData
}

function ReservationBlockRow({block, price, installation}: ReservationBlockRowProps): JSX.Element {
	return (
		<tr>
			<td>{Zones.get(installation, block.zoneId).name}</td>
			<td>{translation(reservationBlockTypeLabel(block.blockType))}</td>
			<td className="number">{formatCurrency(price.amount)}</td>
			<td className="number">{block.spaceCount}</td>
			<td className="number">{formatCurrency(price.amount * block.spaceCount)}</td>
		</tr>);
}

export interface ReservationBlocksProps {
	reservation: ReservationResult;
	installation: InstallationByHostData;
}

export default function ReservationQuote({reservation, installation}: ReservationBlocksProps): JSX.Element {
	if (reservation.payment?.quotation == null) {
		return <></>;
	}

	const totalSpaces = reservation.blocks.reduce((previousValue, currentValue) => {
		return previousValue + currentValue.spaceCount;
	}, 0);

	return (<>
		<div className="card">
			<div role="region" tabIndex={0} className="table--inside-card">
				<table>
					<thead>
					<tr>
						<th>{translation(PermitTranslations.reservation_block__area)}</th>
						<th>{translation(PermitTranslations.block_type)}</th>
						<th className="number">{translation(PermitTranslations.reservation_block__hourly_rate)}</th>
						<th className="number">{translation(PermitTranslations.reservation_block__space_count)}</th>
						<th className="number">{translation(PermitTranslations.reservation_block__total)}</th>
					</tr>
					</thead>
					<tbody>{reservation.blocks.map(((block, index) => {
						const price = reservation.payment?.quotation?.blocks[index];
						return price == null ? null : <ReservationBlockRow key={index} block={block} price={price} installation={installation}/>;
					}))}
					</tbody>
				</table>
			</div>
		</div>

		<div className="card card--padded">
			<div role="region" tabIndex={0} className="table--layout">
				<table>
					<thead>
					<tr>
						<th className="center">{translation(PermitTranslations.reservation__quote__total_spaces)}</th>
						<th className="center">{translation(PermitTranslations.reservation__quote__removed_meters)}</th>
						<th className="center">{translation(PermitTranslations.reservation__quote__total_hours)}</th>
						<th className="center">{translation(PermitTranslations.reservation__quote__total_amount)}</th>
					</tr>
					</thead>
					<tbody>
					<tr>
						<td className="center">{totalSpaces}</td>
						<td className="center">{reservation.meters.length}</td>
						<td className="center">{reservation.payment.quotation.hours}</td>
						<td className="center">{formatCurrency(reservation.payment.quotation.price.totalWithVat)}</td>
					</tr>
					</tbody>
				</table>
			</div>
		</div>
	</>);
}
